import { useTranslation } from 'react-i18next'

import { Flex } from '@percent/lemonade'
import { useProgress } from '@percent/product-nomination-form/hooks'
import { Card, OrganisationPreview } from '@percent/product-nomination-form/ui'
import { HostedFormStep } from '../../HostedForm.types'
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'
import { SubmitNominationFormPayload } from '@percent/product-nomination-form/api/nominationForm/nominationForm.types'
import { useFormContext } from 'react-hook-form'

export const OrganisationResult = () => {
  const { organisation, handleBack, handleNext } = useValidationStepData()
  const { progress } = useProgress()
  const { t } = useTranslation()
  const { setValue } = useFormContext<SubmitNominationFormPayload>()

  const handleNavigateNext = () => {
    return handleNext(HostedFormStep.NOMINEES)
  }

  const handleNavigateBack = () => {
    handleBack()
    setValue('organisationId', '')
  }

  return (
    <Card
      onBack={handleNavigateBack}
      onNext={handleNavigateNext}
      nextButtonLabel={t('hostedValidation.button.next')}
      title={t('hostedValidation.title.isThisNonprofit')}
      progress={progress}
    >
      <Flex direction="column" gap={16} w="100%">
        {organisation && <OrganisationPreview organisation={organisation} />}
      </Flex>
    </Card>
  )
}
